export default __webpack_public_path__ + "static/media/slide1.affcc3dd.png";